module.exports = __webpack_public_path__ + "img/Larghezza180_ok.57d09d1a.png";